<template>
  <v-card class="mt-5" flat outlined>
    <v-card-text class="pt-1 pb-1">
      <v-row class="dispatch-toolbar">
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">Total Daily Gross Cash</div>
          <div class="subtitle-2 black--text">{{ details.total_cash }}</div>
          <!-- <v-text-field
            dense
            @blur="onInput"
            :disabled="!isAdmin"
            v-model="form.total_cash"
            outlined
            hide-details=""
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">EL Cheapo Total Daily Sales</div>
          <div class="subtitle-2 black--text">{{ details.total_sale }}</div>
          <!-- <v-text-field
            dense
            v-model="form.total_sale"
            outlined
            @blur="onInput"
            hide-details=""
            :disabled="!isAdmin"
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">Total Credit Card Charges</div>
          <div class="subtitle-2 black--text">
            {{ details.total_card_charge }}
          </div>
          <!-- <v-text-field
            dense
            outlined
            @blur="onInput"
            hide-details=""
            v-model="form.total_card_charge"
            class="input_35 pr-10"
            :disabled="!isAdmin"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">On Account</div>
          <div class="subtitle-2 black--text">
            {{ details.on_account }}
          </div>
          <!-- <v-text-field
            @blur="onInput"
            dense
            :disabled="!isAdmin"
            outlined
            v-model="form.on_account"
            hide-details=""
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">Approved Check</div>
          <div class="subtitle-2 black--text">
            {{ details.approved_check }}
          </div>
          <!-- <v-text-field
            @blur="onInput"
            dense
            :disabled="!isAdmin"
            outlined
            v-model="form.approved_check"
            hide-details=""
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">Zelle Cash</div>
          <div class="subtitle-2 black--text">
            {{ details.zelle_cash }}
          </div>
          <!-- <v-text-field
            @blur="onInput"
            dense
            :disabled="!isAdmin"
            outlined
            v-model="form.zelle_cash"
            hide-details=""
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
        <v-col cols="6" class="d-flex align-center">
          <div class="subtitle-2 black--text">Total Reimbursements</div>
          <div class="subtitle-2 black--text">
            {{ details.total_reimbusements }}
          </div>
          <!-- <v-text-field
            @blur="onInput"
            dense
            :disabled="!isAdmin"
            outlined
            v-model="form.total_reimbusements"
            hide-details=""
            class="input_35 pr-10"
          ></v-text-field> -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { dispatch } from "../../assets/js/firebase";
export default {
  props: {
    details: Object,
    date: String
  },
  data() {
    return {
      form: {
        total_cash: "",
        total_sale: "",
        total_card_charge: "",
        approved_check: "",
        on_account: "",
        zelle_cash: "",
        total_reimbusements: ""
      }
    };
  },
  watch: {
    details() {
      this.init();
    }
  },
  methods: {
    init() {
      const vm = this;
      Object.keys(vm.form).forEach(key => {
        let val = vm.details[key];
        if (val != undefined) vm.form[key] = val;
      });
    },
    async onInput() {
      const vm = this;
      try {
        await dispatch.doc(vm.date).update(vm.form);
      } catch (error) {
        vm.$alert.show(error.message);
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.dispatch-toolbar {
  .subtitle-2 {
    min-width: 200px;
  }
}
</style>
